import { computed } from 'vue'
import { useAuthStore } from '@/core/auth/auth'
import { can } from '@/core/permissions/can'

export function usePermission() {
  return {
    hasPermission: can,
    userPermissions: computed(() => useAuthStore().user?.permissions || {})
  }
}